import { API_CONFIG } from '@/shared/configs/apiConfig.js'

export default {
  url(payload) {
    // URL pour récupérer tous les utilisateurs de type restaurant (même pattern que riders)
    return `${API_CONFIG.BASE_URLS.PAYMENT}/user/rapidoo-restaurant/all?group=${API_CONFIG.GROUP}`
  },

  parse(raw = {}, payload = {}) {
    // Gestion des erreurs HTTP (404 = pas de données)
    if (raw?.statusCode && raw?.statusCode !== 200 && raw?.statusCode !== 404) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
        raw,
      }
    }

    // 404: pas de données
    if (raw?.statusCode === 404) {
      return {
        statusCode: 200,
        message: 'Ok',
        data: {
          total: 0,
          result: [],
        },
      }
    }

    // Extraire les utilisateurs restaurant depuis la réponse API
    let usersData = raw?.data || []

    // Vérifier que c'est un tableau
    if (!Array.isArray(usersData)) {
      usersData = []
    }

    // Mapper les données pour avoir un format cohérent
    const data = usersData.map(user => ({
      ...user, // Préserver tous les champs originaux de l'API
      // Champs pour le composant
      name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || user.phoneNumber || 'Sans nom',
      email: user.email || '',
      phoneNumber: user.phoneNumber || '',
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      userId: user.userId || user.id || '', // ID de l'utilisateur (lié au restaurant.userId)
      storeId: user.storeId || null, // ID du restaurant associé
    }))

    // === Filtrage selon payload ===
    let filteredData = data
    if (payload?.storeId) {
      filteredData = filteredData.filter(el => el.storeId === payload.storeId || el.userId === payload.storeId)
    }
    if (payload?.userId) {
      filteredData = filteredData.filter(el => el.userId === payload.userId || el.id === payload.userId)
    }
    if (payload?.name) {
      const searchLower = payload.name.toLowerCase()
      filteredData = filteredData.filter(el => {
        const fullName = `${el.firstName || ''} ${el.lastName || ''}`.toLowerCase()
        return fullName.includes(searchLower) || el.email?.toLowerCase().includes(searchLower) || el.phoneNumber?.includes(searchLower)
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      filteredData = [...filteredData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]

        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        return 0
      })
    }

    // === Pagination ===
    const { page = 0, limit = 100 } = payload || {}
    const paginated = filteredData.slice(page * limit, (page + 1) * limit)

    // Stocker dans window.__RAPIDOO_GLOBAL_DATA__ pour accès global (utile pour restaurant.js)
    if (typeof window !== 'undefined') {
      if (!window.__RAPIDOO_GLOBAL_DATA__) {
        window.__RAPIDOO_GLOBAL_DATA__ = {}
      }
      window.__RAPIDOO_GLOBAL_DATA__.restaurantUsers = data
    }

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: filteredData.length,
        result: paginated,
      },
    }
  },
}
